import React, { useState } from 'react'
import "./loginForm.css"
import { TextField } from '@mui/material'
import { Email } from '@mui/icons-material'
import axios from 'axios'
import AlertBox from '../alert/AlertBox'
import { useNavigate } from 'react-router-dom'
import RingLoader from '../loaders/ringLoader/RingLoader'
import { useDispatch, useSelector } from 'react-redux'
import { updateLoginFlg } from '../../redux/features/login/loginSlice'
import { removeEnrollFlg } from '../../redux/features/enroll/enrollSlice'


const alertStateInitials = {
  show: false,
  msg: "",
  type: "success"
}

function LoginForm() {
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
        emailNum: "",
        password: ""
    })
    const [err, setErr] = useState({
        emailNum: false,
        password: false
    })
    const [alertState, setAlertState] = useState(alertStateInitials)
    const [loading, setLoading] = useState(false)

    const dispatch = useDispatch()
    // const isLogin = useSelector(state => state.login.isLogin)



    const onSubmit = async (e)=>{
      e.preventDefault()
      setAlertState(alertStateInitials)      
      const body = formData
      if(!body.emailNum.includes("@") && body?.emailNum?.length !== 10){
        setAlertState({
          show: true,
          type: "error",
          msg: "Enter valid Number"
        })
        return
      }

      setLoading(true)
      await axios.post(process.env.REACT_APP_SERVER+"/api/v1/auth/login",body)
      .then((res)=>{
        const content = res.data?.content
        
        if(res?.data?.success){
          //localStorage.removeItem("createAcc")
          //sessionStorage.setItem("logInFlg", true)
          dispatch(updateLoginFlg(true))
          
          navigate("/dashboard")
        }else{
          setAlertState({
            show: true,
            type: "error",
            msg: "kk"
          })
        }
      })
      .catch((error)=>{
        const content = error?.response?.data
        if(content){
          setAlertState({
            show: true,
            type: "error",
            msg: content?.message
          })
        }
        else{
          setAlertState({
            show: true,
            type: "error",
            msg: error?.message
          })
        }
      })
      .finally(()=>{
        setLoading(false)
      })
    }

    const handleTextChange = (e)=>{
        const {name, value} = e.target
        if(!value){
            setErr({...err, [name]: true})
        }else{
            setErr({...err, [name]: false})
        }
        
        setFormData({...formData, [name]: value})
    }

  return (
    <form onSubmit={onSubmit} class="login form">
    <div class="icon">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 34 34" height="34" width="34">
        <path strokeWidth="round" stroke-width="2.5" stroke="#115DFC" d="M7.08385 9.91666L5.3572 11.0677C4.11945 11.8929 3.50056 12.3055 3.16517 12.9347C2.82977 13.564 2.83226 14.3035 2.83722 15.7825C2.84322 17.5631 2.85976 19.3774 2.90559 21.2133C3.01431 25.569 3.06868 27.7468 4.67008 29.3482C6.27148 30.9498 8.47873 31.0049 12.8932 31.1152C15.6396 31.1838 18.3616 31.1838 21.1078 31.1152C25.5224 31.0049 27.7296 30.9498 29.331 29.3482C30.9324 27.7468 30.9868 25.569 31.0954 21.2133C31.1413 19.3774 31.1578 17.5631 31.1639 15.7825C31.1688 14.3035 31.1712 13.564 30.8359 12.9347C30.5004 12.3055 29.8816 11.8929 28.6437 11.0677L26.9171 9.91666"></path>
        <path strokeWidth="round" stroke-width="2.5" stroke="#115DFC" d="M2.83331 14.1667L12.6268 20.0427C14.7574 21.3211 15.8227 21.9603 17 21.9603C18.1772 21.9603 19.2426 21.3211 21.3732 20.0427L31.1666 14.1667"></path>
        <path stroke-width="2.5" stroke="#115DFC" d="M7.08331 17V8.50001C7.08331 5.82872 7.08331 4.49307 7.91318 3.66321C8.74304 2.83334 10.0787 2.83334 12.75 2.83334H21.25C23.9212 2.83334 25.2569 2.83334 26.0868 3.66321C26.9166 4.49307 26.9166 5.82872 26.9166 8.50001V17"></path>
        <path strokeWidth="round" stroke-linecap="round" stroke-width="2.5" stroke="#115DFC" d="M14.1667 14.1667H19.8334M14.1667 8.5H19.8334"></path>
      </svg>
      <div class="note">
      <label class="header">Sign In</label>

    </div>
    </div>
    {alertState?.show && <AlertBox type={alertState?.type} msg={alertState?.msg} />}

    <div class="note">
      <span class="subtitle">Enter your credentials and click the Proceed button.</span>
    </div>
    <TextField error={err?.emailNum} 
        onChange={handleTextChange}  
        required 
        className='email_input' 
        id="outlined-basic" 
        name='emailNum' 
        type="text" 
        label="Enter your email or phone number" 
        variant="outlined" 
    />
    <TextField error={err?.password} 
        onChange={handleTextChange} 
        name='password' 
        required 
        className='pwd' 
        id="outlined-basic" 
        type="password" 
        label="Enter your password." 
        variant="outlined" 
    />
    

 
    <button type='submit' class="submit">
    {loading? 
                    <RingLoader />:
                    "Proceed"
                }
    </button>
  </form>
  )
}

export default LoginForm